import { ZodError } from 'zod';

export function isCancellationError(errorMessage: string): boolean {
  return errorMessage.includes('Cancel: canceled') || errorMessage.includes('CanceledError');
}

export function extractErrorMessageFromZodError(zodError: unknown, requestTitle: string) {
  if (!(zodError instanceof ZodError)) {
    return `${zodError}`;
  }

  const zodErrorPart = zodError.issues.map((issue) => `[${issue.path.join('.')}]: ${issue.message}`).join('\n');

  return `${requestTitle}.\n${zodErrorPart}`;
}
